import { useState, useEffect } from 'react'

import { ViewIcon, Cancel01Icon } from '@hugeicons/react'
import _ from 'lodash'
import ReactDOM from 'react-dom'
import styled from 'styled-components'


import { useGame } from '../context'

const Word = styled.div`
  user-select: none;
  ${({ shouldBlur }) =>
    shouldBlur &&
    `
      color: transparent !important;
      text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  `}
`

const WordWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`

const WordList = styled.div`
  background: white;
  padding: 18px;
  text-align: center;
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background: rgba(255, 255, 255, 0.95);
  // box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
`

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #555;
  z-index: 11;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Words = () => {
  const { foundWords, allWords, wordsList, showWords } = useGame()
  const [isOpen, setIsOpen] = useState(false)
  const [portal, setPortal] = useState(null)

  useEffect(() => {
    const levelPlayWrapper = document.getElementById('level-play-wrapper')

    if (isOpen) {
      const boardElement = document.querySelector('.board-wrapper')

      if (boardElement) {
        setPortal(boardElement)
        // levelPlayWrapper.style.backgroundColor = 'rgba(255, 255, 255, 0.9)'
      }
    } else {
      setPortal(null)
      // document.getElementById('level-play-wrapper').style.backgroundColor = ''
    }

    return () => {
      // document.getElementById('level-play-wrapper').style.backgroundColor = ''
    }
  }, [isOpen])

  return (
    <div className="mx-auto w-[230px] md:w-[200px] md:p-3 lg:p-6 md:order-2">
      <div className="flex md:block items-center gap-3">
        <span className="text-gray-800 font-bold text-sm lg:text-base block text-center mb-0 md:mb-6">
          Palavras <span className="md:hidden">encontradas</span>{' '}
          {foundWords.length}/{allWords.length}
        </span>
        <button
          type="button"
          className="flex md:hidden text-sm inline-flex items-center justify-center bg-sky-500 text-white rounded-lg items-center gap-2 py-2 px-4"
          onClick={() => setIsOpen(prevState => !prevState)}
        >
          {isOpen ? <Cancel01Icon size={17} /> : <ViewIcon size={17} />}
          {isOpen ? <span>Fechar</span> : <span>Ver</span>}
        </button>
      </div>

      {isOpen &&
        portal &&
        ReactDOM.createPortal(
          <WordWrapper>
            <WordList>
              <CloseButton type="button" onClick={() => setIsOpen(false)}>
                <Cancel01Icon size={20} />
              </CloseButton>
              <div className="py-4">
                <span className="text-gray-800 font-bold text-sm text-center">
                  Palavras encontradas {foundWords.length}/{allWords.length}
                </span>
              </div>
              <div
                className="flex flex-col gap-3"
                style={{ maxHeight: '100%' }}
              >
                {_.sortBy(wordsList, item => foundWords.includes(item)).map(
                  word => {
                    const found = foundWords.includes(word)
                    const blur = !showWords && !found
                    return (
                      <Word
                        key={word}
                        shouldBlur={blur}
                        className={`uppercase ${
                          found
                            ? 'bg-success text-white'
                            : 'bg-gray-200 text-gray-800'
                        } rounded-sm px-3 py-2 text-center font-bold text-xs`}
                      >
                        {blur ? word.replace(/[a-z\d]/gi, '#') : word}
                      </Word>
                    )
                  }
                )}
              </div>
            </WordList>
          </WordWrapper>,
          portal
        )}

      <div className="hidden md:flex flex-col gap-3">
        {_.sortBy(wordsList, item => foundWords.includes(item)).map(word => {
          const found = foundWords.includes(word)
          const blur = !showWords && !found
          return (
            <Word
              key={word}
              shouldBlur={blur}
              className={`uppercase ${
                found ? 'bg-success text-white' : 'bg-gray-200 text-gray-700'
              } rounded-sm px-4 py-2 text-center font-bold text-xs`}
            >
              {blur ? word.replace(/[a-z\d]/gi, '#') : word}
            </Word>
          )
        })}
      </div>
    </div>
  )
}

export default Words
